export default __webpack_public_path__ + "static/media/my-enrollments-blue.910b1fe2.svg";